import { render, staticRenderFns } from "./PaymentCB.vue?vue&type=template&id=7616a984&scoped=true&"
import script from "./PaymentCB.vue?vue&type=script&lang=js&"
export * from "./PaymentCB.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCB.vue?vue&type=style&index=0&id=7616a984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7616a984",
  null
  
)

export default component.exports